import { jsonParse } from "./utils";
import { ensureDefined } from "./utils/types";
import z from "zod";

const rawConfig = jsonParse(ensureDefined(document.getElementById("app_config")).innerText);

const config = z.object({
    standardLifeProcessingDelayBannerEnabled: z.boolean(),
    quoteApiUrl: z.string().url(),
    sentryDsn: z.string().url().or(z.literal("")),
    sentryEnvironment: z.string(),
    sentryReplaySessionSampleRate: z.coerce.number().min(0).max(1),
    sentryReplayErrorSampleRate: z.coerce.number().min(0).max(1),
    sentryThirdPartyFilterBehaviour: z.enum([
        "apply-tag-if-contains-third-party-frames",
        "apply-tag-if-exclusively-contains-third-party-frames",
        "drop-error-if-contains-third-party-frames",
        "drop-error-if-exclusively-contains-third-party-frames",
    ]),
    sessionTimeoutWarning: z.number(),
    sessionTimeoutPage: z.number(),
    cdnUrl: z.string().url(),
    growthBookApiHost: z.string().url().or(z.literal("")),
    growthBookClientKey: z.string().or(z.literal("")),
    toastTimeout: z.number(),
    pollTimeout: z.number(),
    pollFrequency: z.number(),
    getAddressBaseURL: z.string().url(),
    getAddressKey: z.string(),
    sessionCookieKey: z.string(),
    maintenanceMode: z.boolean(),
}).parse(rawConfig);

export default config;
